import { useCallback, useState } from 'react';
import { parseDateFields } from '../http/useHttpFetch';
import { StudyParticipantEventFormDto } from './useGetStudyParticipantEventForm';
import api, { FetchError } from '../../api/api';

export interface StudyParticipantFormEventUpsertDto {
  studyParticipantId: number;
  participantEventId: number;
  participantEventLogId?: number;
  intendedStartDate: Date;
  occurrenceCount: number;
  isFinal?: boolean;
  progress: number;
  formTemplateId: number;
  version: number;
  statePath: string;
  data: any;
  /**
   * duration in minutes spent on form state.
   */
  duration: number;
}

export function useUpsertStudyParticipantEventForm() {
  const [loading, setLoading] = useState<Boolean>(false);
  const [error, setError] = useState<FetchError>();
  const [upsertedEventData, setUpsertedEventData] =
    useState<StudyParticipantEventFormDto>();

  const upsertEventData = useCallback(
    async (formEntityUpsertDto: StudyParticipantFormEventUpsertDto) => {
      const { studyParticipantId, participantEventId } = formEntityUpsertDto;
      const maxRetries = 3;
      const retryDelay = 1000;
      setLoading(true);
      for (let attempt = 0; attempt < maxRetries; attempt++) {
        const result = await api.put(
          `study-participants/${studyParticipantId}/events/${participantEventId}`,
          formEntityUpsertDto
        ).response;
        let json = result ? await result.json() : undefined;
        if (!result.ok) {
          if (attempt === maxRetries - 1) {
            setUpsertedEventData(undefined);
            setError(json as FetchError);
            setLoading(false);
          }
          await new Promise(res => setTimeout(res, retryDelay));
        } else {
          if (json) json = parseDateFields(json);
          setUpsertedEventData(json);
          setLoading(false);
          return;
        }
      }
    },
    []
  );

  return {
    upsertedEventData,
    isUpsertingEventData: loading,
    upsertingEventDataError: error,
    upsertEventData
  };
}
